import { action, makeObservable, observable } from 'mobx';
import { iframeService } from '../services/iframeService';

class LoadingStore {
  progress = 0;

  gameLoading = true;

  timerFinished = false;

  restLoadingResources = null;

  isSoundLoaded = false;

  isGameInitialLoaded = false;

  isTranslationsLoaded = false;

  isPixiLoaded = false;

  isAssetsLoaded = false;

  constructor() {
    makeObservable(this, {
      progress: observable,
      gameLoading: observable,
      isPixiLoaded: observable,
      isSoundLoaded: observable,
      timerFinished: observable,
      isAssetsLoaded: observable,
      isGameInitialLoaded: observable,
      isTranslationsLoaded: observable,
      restLoadingResources: observable.deep,
      setTimerState: action.bound,
      updateLoading: action.bound,
      setIsSoundsLoaded: action.bound,
      setIsAssetsLoaded: action.bound,
      updateProgress: action.bound,
      simulateProgress: action.bound,
    });
  }

  setIsSoundsLoaded(bool) {
    this.isSoundLoaded = bool;
  }

  updateLoading(data) {
    const newState = {
      isPixiLoaded: this.isPixiLoaded,
      isSoundLoaded: this.isSoundLoaded,
      isGameInitialLoaded: this.isGameInitialLoaded,
      isTranslationsLoaded: this.isTranslationsLoaded,
      ...data,
    };

    const { isSoundLoaded, isGameInitialLoaded, isTranslationsLoaded, isPixiLoaded } = newState;

    this.newProgressValue = Math.ceil(
      this.calculateProgress([
        isPixiLoaded,
        isSoundLoaded,
        isGameInitialLoaded,
        isTranslationsLoaded,
      ])
    );

    this.simulateProgress(this.newProgressValue);
    if (!this.gameLoading) {
      iframeService.sendLoadedState();
    }

    this.isPixiLoaded = isPixiLoaded;
    this.isSoundLoaded = isSoundLoaded;
    this.isGameInitialLoaded = isGameInitialLoaded;
    this.isTranslationsLoaded = isTranslationsLoaded;
  }

  async simulateProgress(newValue) {
    for (let i = this.progress; i <= newValue; i += 1) {
      this.updateProgress(i);
      await new Promise((resolve) => setTimeout(resolve, 20));
    }
  }

  updateProgress(newValue) {
    this.progress = newValue;
    this.gameLoading = Math.ceil(this.progress) !== 100;
  }

  setTimerState(bool) {
    this.timerFinished = bool;
  }

  calculateProgress(arr) {
    return arr.reduce((acc, curr, _, self) => acc + (Number(curr) / self.length) * 100, 0);
  }

  setIsAssetsLoaded(bool) {
    this.isAssetsLoaded = bool;
  }
}

export const loadingStore = new LoadingStore();
